import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {StoreState} from "../../../reducers";
import {fetchPlans, MemberPlan, PlansState} from "../../../actions/plans";
import {selectPlan} from "../../../actions/checkout";
import {useNavigate, useLocation} from "react-router-dom";
import PlanCard from "./PlanCard";
import {StudioState} from "../../../actions/studio";
import {AuthState} from "../../../actions/auth";
import baseApi from "../../../apis/baseApi";
import LoadingModal from "./LoadingModal";
import {RegistrationFee} from "./RegistrationFees";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faIdCard} from "@fortawesome/free-solid-svg-icons";
import {getApiErrorMessage} from "../../../utils/api_utils";
import {formatCurrency} from "../../../currency_formatters";


const Plans = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const authState = useSelector<StoreState, AuthState>(state => state.auth)
    const plansState = useSelector<StoreState, PlansState>(state => state.plans)
    const studioState = useSelector<StoreState, StudioState>(state => state.studio)
    const [showLoadingModal, setShowLoadingModal] = useState(false);
    const [registrationFees, setRegistrationFees] = useState<RegistrationFee[]>([])
    const [loadingRegistrationFees, setLoadingRegistrationFees] = useState(false)
    const paramCurrency = useRef<string>();
    const [planError, setPlanError] = useState<string>();

    useEffect(() => {
        if (authState.submitting) {
            return
        }
        if (!plansState.fetched) {
            if (authState.isLoggedIn) {
                dispatch(fetchPlans())
            } else {
                const params = new URLSearchParams(location.search)
                const branch = params.get('branch') || undefined
                const studio = params.get('studio') || undefined
                paramCurrency.current = params.get('currency') || undefined
                if (branch && studio) {
                    dispatch(fetchPlans(branch, studio))
                    // setLoadingRegistrationFees(true)
                    // baseApi.get(`/registration-fees/?studio=${studio}`).then(resp => {
                    //     setRegistrationFees(resp.data.results)
                    // })
                }
                // else {
                //     navigate('/login')
                // }
            }
        }
    }, [dispatch, plansState, location, authState]);

    const getPlanPrice = (plan: MemberPlan) => {
        const planPrice = parseFloat(plan.price)
        if (plan.promotions.length > 0) {
            const promotion = plan.promotions[0]
            if (promotion.is_percent) {
                const price = planPrice - (planPrice * (promotion.discount_amount / 100))
                return price.toFixed(2) //`${currency === "pen" ? "S/" : "$"}${Math.round(price)}`
            } else {
                const price = planPrice - promotion.discount_amount
                return price.toFixed(2)
            }
        }
        if (planPrice > 0) {
            return planPrice.toFixed(2)// `${currency === "pen" ? "S/" : "$"}${Math.round(planPrice)}`
        }
        return "0.00"
    }

    useEffect(() => {
        const paymentProcessor = studioState.studio?.preferences?.payment_processor
        if (authState.isLoggedIn && studioState.studio.id && !loadingRegistrationFees && (paymentProcessor === "ST" || paymentProcessor === "WM")) {
            setLoadingRegistrationFees(true)
            baseApi.get(`/registration-fees/?studio=${studioState.studio.id}`).then(resp => {
                setRegistrationFees(resp.data.results)
            })
        }
    }, [authState, studioState]);

    if (plansState.loading) {
        return <div className='font-size-h5'>Cargando planes...</div>
    }
    if (plansState.error) {
        return <div className="badge badge-danger text-center mt-5 font-size-h4">
            {plansState.error}
        </div>
    }
    return (
        <div>
            <LoadingModal show={showLoadingModal} onHide={() => setShowLoadingModal(false)} errorMessage={planError}/>
            <div hidden={registrationFees.length === 0} className="mt-10">
                <Button size="sm" variant="outline-primary" onClick={() => {
                    navigate("/registration-fees", {state: {registrationFees: registrationFees}})
                }}><FontAwesomeIcon icon={faIdCard}/> Ver Inscripciones</Button>
            </div>
            <div className="row mt-10">
                {plansState.plans.map(plan => {
                    return <div className="col-6 col-md-3" key={plan.id} onClick={() => {
                        dispatch(selectPlan(plan))
                        setPlanError(undefined)
                        if (!authState.isLoggedIn) {
                            const params = new URLSearchParams(location.search)
                            const studio = params.get('studio') || undefined
                            const branch = params.get('branch') || undefined
                            let path = '/login';
                            if (studio) {
                                path += `?studio=${studio}`
                            }
                            if (branch) {
                                path += `&branch=${branch}`
                            }
                            navigate(path)
                        } else if (studioState.studio.preferences.payment_processor === "ST") {
                            if (!plan.is_subscription && parseFloat(plan.price) > 0) {
                                const params = new URLSearchParams(location.search)
                                const branch = params.get('branch') || undefined
                                navigate(`/stripe-checkout?branch=${branch}`)
                            } else {
                                navigate("/checkout")
                            }
                        } else if (studioState.studio.preferences.payment_processor === "MP") {
                            navigate("/checkout-mp")
                        } else if (studioState.studio.preferences.payment_processor == "WM") {
                            setShowLoadingModal(true)
                            if (studioState.studio.id === "8772ddbc-bdf1-41fe-b882-57d0cfa5e9ef") {
                                // RUSH RIDE
                                let body = {plan: plan.id, amount: getPlanPrice(plan), description: plan.name}
                                baseApi.post("/sales/paguelofacil/", body).then(resp => {
                                    setShowLoadingModal(false)
                                    let url = resp.data.data.url
                                    url += "&r=wompi.sv"
                                    window.open(url, "_self")
                                }).catch(err => setPlanError(getApiErrorMessage(err)))
                                return
                            }

                            let url = `/wompi/link/?plan=${plan.id}`
                            if (plan.promotions.length > 0) {
                                const promotion = plan.promotions[0]
                                url += `&promotion=${promotion.id}`
                            }
                            baseApi.get(url).then(resp => {
                                setShowLoadingModal(false)
                                let url = resp.data.urlEnlace
                                window.open(url, "_self")
                            }).catch(err => setPlanError(getApiErrorMessage(err)))
                        } else {
                            alert("Lo sentimos, tu estudio aun no acepta pagos en linea.")
                        }

                    }}>
                        <PlanCard plan={plan} paramCurrency={paramCurrency.current}/>
                    </div>
                })}
            </div>
        </div>
    );
};

export default Plans;
